import * as React from 'react'

export const generateClosingDisclosure = (phoneNumber): JSX.Element => (
  <p>
    Engine by MoneyLion is the technology platform powering financial services online. Engine by MoneyLion's API enables
    its partners to connect their users with real-time decisions and personalized offers and rates from premium
    financial services providers. Engine by MoneyLion offices are located at 50 West 23rd Street, Suite 700, New York,
    NY 10010, Telephone number: {phoneNumber}. This site is directed at, and made available to, persons in the
    continental U.S., Alaska and Hawaii only.
  </p>
)

export const helocDisclosure = (
  <>
    <h4>Home Equity Line of Credit (HELOC)</h4>
    <p>
      We are not a lender or correspondent lender. We do not make mortgage loans or commitments or take applications and
      cannot guarantee acceptance into any particular loan program by any Lender, or specific loan terms or conditions.
      We do not act as an agent or advisor to you or any financial service provider. We do not take applications, make
      loans or credit decisions in connection with loans, issue commitments or lock-in agreements, or fund loans. Our
      services are purely administrative. Any loan may be co-brokered but not in South Carolina. This does not create an
      exclusive relationship and remains in effect only as long as you seek to use our services. You may discontinue
      this relationship at any time, without notice, at no cost or penalty to you.
    </p>
    <p>
      Any loan request you submit is NOT an application for credit. Rather, it is a request to be matched with
      prospective third-party lenders to receive conditional loan offers from those lenders. Any lender will require you
      to submit a loan application to them for their consideration before extending an offer. We do not issue loan
      approvals, loan commitments, or make any guarantees on behalf of any lender. We do not connect you with every
      lender in the market, so other lenders and loans not listed on our service may be available to you, and those
      other loans may have different terms and conditions, including lower rates. We cannot guarantee the lowest price
      or best terms available in the market. We do not endorse or recommend particular lenders or products. Your
      personal financial situation is unique, and it is your responsibility to evaluate the information and content
      provided, before making any financial decisions.
    </p>
    <p>
      The lenders are solely responsible for their services to you, and you agree that we will not be liable for any
      damages or costs of any type arising out of or in any way connected with your use of such services. You understand
      that lenders may keep your loan request information and any other information provided by us or received by them
      in the processing of your loan request, whether or not you are qualified for a loan with them or obtain a loan
      from them. If your loan request is forwarded to a prospective lender that makes you an offer, you should receive
      from the lender a disclosure, sometimes referred to as a good faith estimate (GFE) of the settlement costs of your
      loan, and now generally referred to as a Loan Estimate form as required by the TILA-RESPA Integrated Disclosure
      Act. The disclosure sets forth the various loan terms and costs involved, such as a credit report fee, property
      appraisal fee, or other third-party fees in connection with your loan.
    </p>
    <p>
      The interest rate quoted in connection with the loan you select is subject to change without notice, unless and
      until an interest rate lock-in agreement has been entered into between you and the lender. We do not offer
      interest rate lock-in agreements and do not guarantee any interest rate quoted by a participating lender. If you
      enter a lock-in agreement with the lender and are required to pay an interest rate lock-in fee, the terms and
      conditions under which the interest rate lock-in fee may be refunded, if any, will be set by the lender. The
      documentation you receive will include the information or terms and conditions on the refundability of any fees
      paid. We do not offer or provide any refund on behalf of any lender.
    </p>
    <p>
      We support the principles of the federal Equal Credit Opportunity Act (the “ECOA”). We do not engage in business
      practices that discriminate on the basis of race, color, religion, national origin, sex, marital status, age
      (provided the applicant has the capacity to contract), the fact that all or part of the applicant's income derives
      from a public assistance program, or the fact that the applicant has in good faith exercised any right under the
      Consumer Credit Protection Act. Similarly, we are committed to compliance with any applicable state and local
      anti-discrimination laws. Under the ECOA, you are entitled to receive a copy of any appraisal.
    </p>
    <p>
      <i>
        If your home value is higher than your outstanding mortgage balance(s) you may be able to borrow against the
        portion of equity available in your home. A HELOC is a financial product that takes a security interest in your
        home using a credit line. Typically, HELOCs are broken down into two distinct phases. A draw period and
        repayment period.
      </i>
    </p>
    <p>
      <i>
        During the draw period, homeowners can borrow as much as they'd like within the credit line amount. Usually,
        interest-only payments are allowed on the amount drawn. You may also pay back the amount borrowed and the line
        is replenished. Once the draw period ends, you can no longer withdraw money from the line and the borrower must
        pay off the principal amount of the HELOC, with interest. The length of these terms and product offerings will
        vary by lender and each individual situation. When a HELOC has a variable rate, your interest rate may go up or
        down in relation to an index, economic conditions, and rate restrictions provided by the lender. Some HELOCs may
        be subject to interest rate adjustment caps which means that there is a maximum your interest rate may go up or
        down for a set period (i.e. 6 months or 1 year) and for the life of the loan. Example: A Variable Rate HELOC
        with interest rate caps of 2% for the first year and 1% each year afterward for the life of the loan.
      </i>
    </p>
    <p>
      <i>
        Rates and terms may change at any time and will be subject to property type, loan amount, credit history, lien
        position, loan-to-value (LTV) ratio, debt-to-income (DTI) ratio, FICO score and draw amount at closing. Rates
        are subject to change daily and minimum line amounts may apply. All accounts are subject to individual lender
        approval. Any minimum periodic payments stated by a lender may result in a balloon payment if only the minimum
        is made. The amount and timing of the balloon payment is at the discretion of the lender. Please evaluate all
        terms prior to making any financial decision.
      </i>
    </p>
    <p>
      <i>Other helpful information is available here: </i>
      <a href="https://files.consumerfinance.gov/f/201204_CFPB_HELOC-brochure.pdf" target="_blank">
        https://files.consumerfinance.gov/f/201204_CFPB_HELOC-brochure.pdf
      </a>
    </p>
    <p>
      HELOC Example <br />
      Home value $300,000 <br />
      $300,000 x 80% = $240,000. <br /> You owe $100,000 on your first mortgage: $240,000 – $100,000 = $140,000. <br />{' '}
      In the above scenario, assuming your lender caps the maximum loan-to-value ratio of 80%, you could potentially
      qualify for a HELOC with a maximum credit line of $140,000.
    </p>
  </>
)

export const representativeExample = (
  <p>
    Representative Example: If you borrow $5,000 on a 36 month repayment term and at a 10% APR, the monthly repayment
    will be $161.34. Total repayment will be $5,808.24. Total interest paid will be $808.24.
  </p>
)

export const aprDisclosure = (
  <p>
    Annual Percentage Rate (APR) Disclosure: The Annual Percentage Rate is the rate at which your loan accrues interest.
    It is based upon the amount of your loan, the cost of the loan, term of the loan, repayment amounts and timing of
    payments and payoff. By law, the lender or lending partner must show you the APR before you enter into the loan.
    States have laws that may limit the APR that the lender or lending partner can charge you. Rates will vary based on
    your credit worthiness, loan size, amongst other variables, with the lowest rates available to customers with
    excellent credit. Minimum and maximum loan amounts and APRs may vary according to state law and lender or lending
    partner. We recommend that you read the lender's and/or lending partner's personal terms and conditions in full
    before proceeding for any loan.
  </p>
)

export const autoPaymentDisclosure = (
  <>
    <p>
      The automobile payments displayed do not include taxes, licensing and fees. The actual interest rate, annual
      percentage rate and payment may vary based on the specific terms of the automobile loan selected, verification of
      your credit history, license, taxes, fees, money down, trade-in, rebates, cash down, and type of automobile as
      well as other factors as determined by lenders. Certain institutions may include minimum and/or maximum loan
      amounts based on several factors such as your income, key credit characteristics, and the vehicle you are
      refinancing. Restrictions as to the type of vehicle and age of the vehicle and other characteristics may also
      apply. Our automobile refinance partners offer APRs between 1.49%-12%. Variable rates will fluctuate over the term
      of the loan.
    </p>
  </>
)
